module.exports = __webpack_public_path__ + "img/文献速递@2x.ed022ae4.png";